import { NewRelicLogHelper } from '#shared/utils/newRelicLogHelper'
import { LOG_LEVEL } from '#shared/constant/log'

export const postWindowBridge = <Key extends AppWindowBridgeKey>(
  key: Key,
  bridgeValue: AppWindowBridgeMessageMap[Key]
): boolean => {
  if (typeof window === 'undefined') return false

  const bridge: WindowBridge | undefined = window[key]
  if (!bridge) return false

  try {
    bridge.postMessage(bridgeValue)
    return true
  } catch (error) {
    // ユーザーのコンソールには出さず、New Relicにのみ WARN ログを送信する
    const noticeError =
      error instanceof Error ? error : new Error(String(error))

    NewRelicLogHelper({
      level: LOG_LEVEL.WARN,
      category: 'windowBridge',
      message: 'postWindowBridge failed',
      error: noticeError,
      detail: {
        module: 'windowBridge',
        action: 'postWindowBridge',
        bridgeKey: key,
        errorName: noticeError.name,
      },
    })

    return false
  }
}
